import base from './baseApi';

const { urls, methods, execute } = base();

export type UpsertRecentSearchPayload = {
   organizationId?: string;
   mapboxId: string;
   placeName: string;
   center: string;
   mapboxObject?: any;
   checkin: string;
   checkout: string;
   adults?: number;
   children?: number;
   rooms?: number;
   yearOlds?: number[];
   isPet?: boolean;
   countryCode?: string;
};

export type RecentSearchDto = {
   id: string;
   userId: string;
   organizationId: string | null;
   mapboxId: string;
   placeName: string;
   center: string;
   mapboxObject?: any;
   checkin: string;
   checkout: string;
   adults: number;
   children: number;
   rooms: number;
   yearOlds: number[] | null;
   isPet: boolean;
   countryCode: string | null;
   lastSearchedAt: string;
   created: string;
};

const listRecentSearches = (limit?: number) => {
   const header = { authorization: true };
   return execute(methods.GET, urls.recentSearch.list, header, limit ? { limit } : {});
};

const upsertRecentSearch = (payload: UpsertRecentSearchPayload) => {
   const header = { authorization: true };
   return execute(methods.POST, urls.recentSearch.upsert, header, payload);
};

const deleteRecentSearch = (id: string) => {
   const header = { authorization: true };
   const url = urls.recentSearch.remove.replace(':id', id);
   return execute(methods.DELETE, url, header);
};

const clearRecentSearches = () => {
   const header = { authorization: true };
   return execute(methods.DELETE, urls.recentSearch.list, header);
};

export { listRecentSearches, upsertRecentSearch, deleteRecentSearch, clearRecentSearches };
